
const Classes = (theme) => ({
  row: {
    marginTop: "65px",
    minHeight: "calc(100vh - 65px)",
    background: "#fff",
  },
  formContainer: {
    padding: "15px",
    height: "100%",
    
  },
  inputField: {
    width: "100%",
  },
  userType: {
    color: "#f8c144",
    fontSize: 24,
    margin: "30px 0",
  },
  imgError: {
    color: " #f44336",
    fontSize: "0.75rem",
    marginLeft: "15px",
    marginTop: "5px",
  },
  loginDesc: {
    fontSize: 15,
    fontWeight: 400,
    marginBottom: 10,
    marginTop: 20,
    color: "#f44336",
  }
});

export default Classes